<div class="modal-header" [ngClass]="{ 'border-bottom-none': !isHighRisk }">
	<h5 class="modal-title w-100 text-center">
		<strong *ngIf="isHighRisk">{{ title | translate }}</strong>
	</h5>
	<button
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
		(click)="hide()"
	></button>
</div>

<div class="modal-body d-flex flex-column align-items-center">
	<img
		*ngIf="showWarningIcon"
		[src]="
			isHighRisk
				? 'assets/icons/modal/warning.svg'
				: 'assets/icons/modal/warning-clouds.svg'
		"
		alt=""
		[ngClass]="isHighRisk ? 'warning-icon' : 'warning-clouds-icon'"
	/>

	<h5 class="title text-dark fw-semibold" *ngIf="!isHighRisk">
		{{ title | translate }}
	</h5>

	<p class="text-center">{{ body | translate }}</p>

	<div class="form-check" *ngIf="isHighRisk">
		<input
			id="checkHighRisk"
			type="checkbox"
			class="form-check-input"
			(click)="changeStateBtnDeleteHighRisk($event.target)"
		/>
		<label for="checkHighRisk" class="form-label">
			{{ "GLOBAL.MODAL_DELETE_HIGH_RISK.TEXT_CHECKBOX" | translate }}
		</label>
	</div>
</div>

<div class="modal-footer">
	<div *ngIf="!isHighRisk">
		<button
			[disabled]="loading$ | async"
			type="button"
			class="btn btn-secondary me-4"
			(click)="confirm()"
		>
			<ng-container *ngIf="loading$ | async">
				<span
					class="spinner-border spinner-border-sm me-2"
					role="status"
				></span>
			</ng-container>
			{{ primaryButton | translate }}
		</button>
		<button type="button" class="btn btn-danger me-0" (click)="decline()">
			{{ secondaryButton | translate }}
		</button>
	</div>

	<div *ngIf="isHighRisk">
		<button
			type="button"
			class="btn btn-secondary me-4"
			(click)="decline()"
		>
			{{ secondaryButton | translate }}
		</button>
		<span
			tooltip="{{
				isDisabledBtnDeleteHighRisk
					? ('GLOBAL.MODAL_DELETE_HIGH_RISK.TOOLTIP.DELETE'
						| translate)
					: ''
			}}"
		>
			<button
				id="btnDeleteHighRisk"
				type="button"
				class="btn btn-primary btn-danger me-0"
				(click)="confirmDelete()"
				[disabled]="(loading$ | async) || isDisabledBtnDeleteHighRisk"
			>
				<ng-container *ngIf="loading$ | async">
					<span
						class="spinner-border spinner-border-sm me-2"
						role="status"
					></span>
				</ng-container>
				{{ primaryButton | translate }}
			</button>
		</span>
	</div>
</div>
